import { CPF_SIZE } from '@shared/constants/cpf-validator.constants';

export function formatCpfCnpj(documentNumber?: string): string {
  // CPF é numérico; CNPJ pode ser alfanumérico (12 primeiras posições, RFB jul/2026).
  const cleaned = documentNumber?.toUpperCase().replace(/[^0-9A-Z]/g, '') || '';

  if (!cleaned) {
    return '';
  }

  // CPF: 11 dígitos numéricos.
  if (cleaned.length === CPF_SIZE && /^\d{11}$/.test(cleaned)) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  // CNPJ: 14 caracteres (alfanumérico nas 12 primeiras posições), agrupado por posição.
  if (cleaned.length === 14) {
    return cleaned.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5');
  }

  return cleaned;
}

export function formatPhoneNumber(value: string): string {
  if (!value) return '';

  // Remove tudo que não é número
  const digits = value.replace(/\D/g, '');

  // Celular: (00) 00000-0000 (11 dígitos)
  if (digits.length === 11) {
    return digits.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  // Fixo: (00) 0000-0000 (10 dígitos)
  if (digits.length === 10) {
    return digits.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  // Caso tenha DDI ou formato desconhecido, retorna o original ou apenas limpo
  return value;
}

/**
 * Retorna true se o valor (formatado ou cru) aparenta ser um número de telefone.
 * Telefone celular: 11 dígitos; fixo: 10 dígitos.
 * Valores já formatados por formatPhoneNumber sempre contêm '('.
 */

export const PHONE_MOBILE_MASK = '(00) 00000-0000';
export const PHONE_LANDLINE_MASK = '(00) 0000-0000';

export function isPhoneNumber(value: string, checkFormat = true): boolean {
  if (!value) return false;
  const digits = value.replace(/\D/g, '');
  // CPF tem 11 dígitos, então só conta como telefone se vier formatado com '(' (quando checkFormat for true)
  if (digits.length === 11) return checkFormat ? value.includes('(') : true;
  return digits.length === 10;
}
